export const FLUXER_TOKEN = "FLUXER_TOKEN";
export const SELECTED_INSTALLATION = "SELECTED_INSTALLATION";
export const MONTHS = ["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"]